export const ACCOUNT_BAR_HEIGHT = 57;
export const SUPPORT_EMAIL = "support@akash.network";
